import { Button, PageHeader } from 'antd'
import React from 'react'
import { Link } from 'react-router-dom'
import ContraVoucherEntryView from '../../components/account/contra/ContraVoucherEntryView'
import GeneralVoucherEntryView from '../../components/account/general/GeneralVoucherEntryView'
import AdminBreadCrumb from '../../components/layout/AdminBreadCrumb'

const GeneralVoucher = () => {
  return (
    <div className='inside-main-content'>

      <AdminBreadCrumb />

        <div className="box-style" >
            <PageHeader
            ghost={false}
            onBack={() => window.history.back()}
            title="General Voucher Entry"
            subTitle=""
            extra={[
                <Link to={`/generalvoucher/list`} key="reg_list">
                <Button key="1" shape='round' className='custom-button-white'> List</Button>
                </Link>

            
            ]}
            >

            </PageHeader>


            <GeneralVoucherEntryView />

        </div>
    </div>
  )
}

export default GeneralVoucher